import React, {useEffect} from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import { RouteNames } from '../constants'
import Login from '../pages/auth/login'
import ForgetPassword from "../pages/auth/forget-password";
import ResetPassword from "../pages/auth/reset-password";
import DashboardLayout from "../components/Layouts/DashboardLayout";
import EmailVerified from "../pages/auth/email-verified";
import Signup from "../pages/auth/signup";
import Onboarding from "../pages/onboarding/onboarding";
import ProtectedRoutes from "./protectedRoutes";
import Dashboard from "../pages/dashboard/dashboard";
import Feedback from "../pages/feedback/feedback";
import MyReferrals from "../pages/my-referrals/my-referrals";
import RegisterAFriend from "../pages/register-a-friend/register-a-friend";
import AccountSettings from "../pages/account-settings/account-settings";
import RequestStatement from "../pages/request-statement/request-statement";
import RequestStatementThirdParty from "../pages/request-statement-third-party/request-statement-third-party";
import Transactions from "../pages/transactions/transactions";
import TransferRSA from "../pages/transfer-rsa/transfer-rsa";
import {useAppDispatch} from "../redux/hooks";
import {populateUserData} from "../redux/auth/authSlice";
import Support from "../pages/support/support";
import NextOfKin from "../pages/next-of-kin/next-of-kin";
import Employer from "../pages/employer/employer";
import InitiateBenefit from "../pages/benefits/initiate-benefit";
import VirtualNin from "../pages/virtual-nin/virtual-nin";
import MyMemorableDays from "../pages/my-memorable-days/my-memorable-days";
import MissingMonths from "../pages/missing-months/missing-months";
import PensionCalculator from "../pages/pension-calculator/pension-calculator";
import FundTransfer from "../pages/fund-transfer/fund-transfer";
import TrackBenefit from "../pages/benefits/track-benefit";
import PrivacyPage from "../pages/privacy-policy/privacy-policy";
import WhistleBlowing from "../pages/whistleblowing/whistleblowing";
import CorgRequest from "../pages/corg-request/corg-request";
import FAQs from "../pages/faqs/faqs";
import TrackBenefitPage from "../pages/benefits/track-benefit";
import SelfContributionPage from "../pages/self-contribution/self-contribution";
import BeneficiariesPage from "../pages/beneficiaries/beneficiaries-list";
import RecapturePage from "../pages/recapture/recapture";
import RecaptureStatusPage from "../pages/recapture/status";
import RegisterPage from "../pages/auth/register";
import CompleteRegistrationPage from "../pages/registration/complete-registration";



export const AppRoutes = () => {
  const dispatch = useAppDispatch();
  useEffect(()=>{
    const userData = localStorage.getItem('user');
    if(!userData) return;
    // @ts-ignore
    dispatch(populateUserData(JSON.parse(userData)));
  }, [])
    return (
        <Routes>
            <Route path={RouteNames.EMAIL_VERIFIED} element={<EmailVerified/>}/>
            <Route path={RouteNames.FORGOT_PASSWORD} element={<ForgetPassword/>}/>
            <Route path={RouteNames.LOGIN} element={<Login/>}/>
            <Route path={RouteNames.REGISTER} element={<RegisterPage/>}/>
            <Route path={RouteNames.RESET_PASSWORD} element={<ResetPassword/>}/>
            <Route path={RouteNames.SIGNUP} element={<Signup/>}/>
            <Route path={RouteNames.ONBOARDING} element={<Onboarding />}/>
            <Route path={RouteNames.PRIVACY} element={<PrivacyPage />}/>
            <Route path={RouteNames.FAQS} element={<FAQs />}/>
            <Route element={<ProtectedRoutes />}>
                <Route element={<DashboardLayout/>}>
                        <Route path={RouteNames.HOME} element={<Dashboard/>}/>
                        <Route path={RouteNames.ACCOUNT_SETTINGS} element={<AccountSettings/>}/>
                        <Route path={RouteNames.CORG_REQUEST} element={<CorgRequest />}/>
                        <Route path={RouteNames.DASHBOARD} element={<Navigate to={RouteNames.HOME}/>}/>
                        <Route path={RouteNames.EMPLOYER} element={<Employer />}/>
                        <Route path={RouteNames.FEEDBACK} element={<Feedback/>}/>
                        <Route path={RouteNames.FUND_TRANSFER} element={<FundTransfer />}/>
                        <Route path={RouteNames.INITIATE_BENEFIT} element={<InitiateBenefit />}/>
                         
                        <Route path={RouteNames.TRACK_BENEFIT} element={<TrackBenefit />}/>
                        <Route path={RouteNames.MISSING_MONTHS} element={<MissingMonths />}/>
                        <Route path={RouteNames.SELF_CONTRIBUTION} element={<SelfContributionPage />}/>
                        <Route path={RouteNames.MY_MEMORABLE_DAYS} element={<MyMemorableDays />}/>
                        <Route path={RouteNames.MY_REFERRALS} element={<MyReferrals/>}/>
                        <Route path={RouteNames.NEXT_OF_KIN} element={<NextOfKin />}/>
                        <Route path={RouteNames.BENEFICIARIES} element={<BeneficiariesPage />}/>
                        <Route path={RouteNames.PENSION_CALCULATOR} element={<PensionCalculator />}/>
                        <Route path={RouteNames.REGISTER_A_FRIEND} element={<RegisterAFriend/>}/>
                        <Route path={RouteNames.REQUEST_STATEMENT} element={<RequestStatement/>}/>
                        <Route path={RouteNames.REQUEST_STATEMENT_THIRD_PARTY} element={<RequestStatementThirdParty />}/>
                        <Route path={RouteNames.SUPPORT} element={<Support />}/>
                        <Route path={RouteNames.TRANSACTIONS} element={<Transactions/>}/>
                        <Route path={RouteNames.TRANSFER_RSA} element={<TransferRSA/>}/>
                        <Route path={RouteNames.VIRTUAL_NIN} element={<VirtualNin />}/>
                        <Route path={RouteNames.RECAPTURE} element={<RecapturePage />}/>
                        <Route path={RouteNames.RECAPTURE_STATUS} element={<RecaptureStatusPage />}/>
                        <Route path={RouteNames.REGISTER_COMPLETE} element={<CompleteRegistrationPage />}/>
                        <Route path={RouteNames.WHISTLE_BLOWING} element={<WhistleBlowing />}/>
                    </Route>
            </Route>
            <Route path={'*'} element={<div>404 Not found </div>}/>
        </Routes>

    );
}
